import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background-color: #001529;
  color: rgba(255, 255, 255, 0.65);
  padding: 2rem 0;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FooterLinks = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
  
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: center;
  }
`;

const FooterLink = styled(Link)`
  color: rgba(255, 255, 255, 0.65);
  margin: 0 1rem;
  transition: color 0.3s;
  
  &:hover {
    color: #fff;
  }
  
  @media (max-width: 576px) {
    margin: 0.5rem 0;
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-bottom: 1rem;
`;

const IcpRecord = styled.div`
  text-align: center;
  
  a {
    color: rgba(255, 255, 255, 0.65);
    transition: color 0.3s;
    
    &:hover {
      color: #fff;
    }
  }
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterLinks>
          <FooterLink to="/">首页</FooterLink>
          <FooterLink to="/ai-coding">AI编码</FooterLink>
          <FooterLink to="/ai-creation">AI创作</FooterLink>
          <FooterLink to="/knowledge">知识链接</FooterLink>
          <FooterLink to="/about">关于我</FooterLink>
        </FooterLinks>
        <Copyright>
          &copy; {new Date().getFullYear()} 谦言万语 版权所有
        </Copyright>
        <IcpRecord>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
            鄂ICP备2022010193号-1
          </a>
        </IcpRecord>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 